// The shell's Refresh button, like the iPhone's pull-to-refresh. It does two things:
// 1. Pulls the change feed now: SyncIndicator calls the running engine's `pullNow()` itself (through
//    useOptionalSyncEngine from '@/sync/hooks'), so a refresh works whether or not anything listens for the event below.
//    The sync package must NOT also pull on REFRESH_EVENT, or every press would queue two pulls.
// 2. Broadcasts REFRESH_EVENT on window, for screens whose data is not in the feed (TanStack Query RPCs such as
//    `team_roster`, `team_metrics`, `my_invitations`): they listen and invalidate their queries.

export const REFRESH_EVENT = 'gt:refresh';

/** Tell screens to refetch their server queries. Safe to call anywhere; a no-op when nothing is listening. */
export function requestRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(REFRESH_EVENT));
}

/**
 * The Refresh action: an immediate pull through the engine (when the shell is inside SyncProvider), then the
 * broadcast. `pullNow` reports failures through the sync status ("Sync problem", "Offline"), never by throwing.
 */
export function refreshNow(engine: { pullNow(): Promise<void> } | null): void {
  if (engine) void engine.pullNow().catch(() => {});
  requestRefresh();
}
